import {PageContainer} from '@ant-design/pro-components';
import style from './index.less';
import {LeftOutlined} from "@ant-design/icons";

export default (props: any) => {
    return (
        <PageContainer
            title={false}
            className={style.container}
            header={{
                ...props.header,
            }}
            style={{width: '100%', padding: 0}}
            {...props}
        >
            {props.children}
        </PageContainer>
    );
};
